export enum TabBarDistributionEnum {
  Fluid = 'fluid',
  Even = 'even',
}
